import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "showBorderTop", "showBorderBottom", "showBorderLeft", "showBorderRight"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import styled, { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "PPUIGridItem__StyledDiv"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
const gridItemStylePropKeys = {
  gridColumnStart: true,
  gridArea: true,
  placeSelf: true,
  gridRowStart: true,
  gridColumn: true
};
function filterGridItemProps(props) {
  const gridItemProps = {};
  const rest = {};
  Object.keys(props).forEach(key => {
    if (key in gridItemStylePropKeys) {
      gridItemProps[key] = props[key];
    } else {
      rest[key] = props[key];
    }
  });

  // Trellis filterProps only supports tokenized props, which does NOT include grid style props
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(rest);
  return {
    gridItemProps,
    domProps,
    tokenProps,
    callbackProps
  };
}
export const PPUIGridItem = _ref => {
  let {
      children,
      showBorderTop,
      showBorderBottom,
      showBorderLeft,
      showBorderRight
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    gridItemProps,
    domProps,
    tokenProps,
    callbackProps
  } = filterGridItemProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const theme = useTheme();
  const border = `${theme.borderWidth[100]} solid ${theme.color['border-core-subtle']}`;
  return /*#__PURE__*/_jsx(StyledDiv, Object.assign({}, domProps, callbackProps, {
    $cssStyles: Object.assign({}, cssStyles, gridItemProps, {
      borderBlockStart: showBorderTop ? border : undefined,
      borderBlockEnd: showBorderBottom ? border : undefined,
      borderInlineStart: showBorderLeft ? border : undefined,
      borderInlineEnd: showBorderRight ? border : undefined
    }),
    children: children
  }));
};